module.exports = __webpack_public_path__ + "media/operate_bg.95b3ef24.mp4";